import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { notification } from 'antd';

import StorageReportContext from '@totem/components/administration/storageReporting/StorageReportContext';
import { StorageSnapshot } from '@totem/components/administration/storageReporting/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { STORAGE_REPORT_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children: ReactNode;
};

const StorageReportContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);

  const [loading, setLoading] = useState(true);
  const [snapshot, setSnapshot] = useState<StorageSnapshot | null>(null);
  const [refreshData, setRefreshData] = useState(true);

  useEffect(() => {
    if (!refreshData) {
      return;
    }

    setLoading(true);

    fetch(STORAGE_REPORT_ENDPOINT, {
      method: 'GET',
      headers: new Headers({ Authorization: `Bearer ${getApiToken()}` }),
    })
      .then((res) => {
        // 404 until the first nightly snapshot has run
        if (res.status === 404) {
          return null;
        }
        if (!res.ok) {
          throw new Error(res.statusText);
        }
        return res.json();
      })
      .then((result: StorageSnapshot | null) => setSnapshot(result))
      .catch(() => {
        notification.error({ message: 'Failed to load storage report.' });
      })
      .finally(() => setLoading(false));

    setRefreshData(false);
  }, [refreshData, getApiToken]);

  return (
    <StorageReportContext.Provider
      value={{
        loading,
        snapshot,
        onRefresh: () => setRefreshData(true),
      }}
    >
      {children}
    </StorageReportContext.Provider>
  );
};

export default StorageReportContainer;
